import React from "react";
import UserMenu from "../../component/atom/Icon/SVG/UserMenu";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../config/router/router.config";
import { adminRoute } from "./admin/Admin.route";
import { maintainerRoute } from "./maintainer/Maintainer.route";

export type UserRouteParam = DefaultRouteParam;

export const userSub: RouteConfig[] = [maintainerRoute, adminRoute];

export const userRoute: RouteConfig = {
  name: "User",
  Component: React.lazy(() => import("./User.view")),
  path: "/user",
  isPrivate: true,

  options: {
    icon: <UserMenu />,
    label: "User",
    testID: "MenuUser",
    hasSub: userSub,
  },
};
